import type { Holiday, HolidayCreate } from '../models/holiday.types';

export function buildDuplicatedHolidays(
    source: Holiday[],
    existingTargetDates: string[],
    sourceYear: number,
    targetYear: number
): HolidayCreate[] {
    const existing = new Set(existingTargetDates);

    return source
        .map((holiday) => ({
            date: shiftYear(holiday.date, sourceYear, targetYear),
            name: holiday.name,
            scope: holiday.scope,
            recurring: holiday.recurring,
        }))
        .filter((holiday) => holiday.date !== null && !existing.has(holiday.date))
        .map((holiday) => holiday as HolidayCreate);
}

function shiftYear(isoDate: string, sourceYear: number, targetYear: number): string | null {
    const [year, month, day] = isoDate.split('-');
    if (Number(year) !== sourceYear || !month || !day) return null;

    if (month === '02' && day === '29' && !isLeapYear(targetYear)) return null;

    return `${targetYear}-${month}-${day}`;
}

function isLeapYear(year: number): boolean {
    return (year % 4 === 0 && year % 100 !== 0) || year % 400 === 0;
}
